import { render } from "./App.vue?vue&type=template&id=2776dfde&scoped=true"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=2776dfde&scoped=true&lang=css"

import exportComponent from "/home/drdilyor/workspace/minesweeper/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2776dfde"]])

export default __exports__